<template>
  <div
    class="payment-method"
    :class="{
      'payment-method_selected': selected,
      'payment-method_disabled': disabled,
    }"
    @click="onSelect"
  >
    <v-icon
      v-if="crossed"
      class="payment-method__crossed"
      color="#EB5757"
      small
    >
      mdi-close
    </v-icon>
    <v-radio-group
      v-else
      :value="selected"
      class="payment-method__radio ma-0 pa-0"
      hide-details
      dense
    >
      <v-radio :value="true" :disabled="disabled" color="#FF9100" />
    </v-radio-group>

    <card-brand-badge v-if="brand" :brand="brand" class="payment-method__brand" />

    <div class="payment-method__info">
      <div class="payment-method__title">
        {{ title }}
        <span v-if="badge" class="payment-method__badge">{{ badge }}</span>
      </div>
      <div v-if="subtitle" class="payment-method__subtitle">
        {{ subtitle }}
      </div>
    </div>

    <div v-if="mark" class="payment-method__mark" :class="markClass">
      {{ mark }}
    </div>

    <slot name="trailing" />
  </div>
</template>

<script>
  import CardBrandBadge from '@/components/billing/CardBrandBadge.vue'

  export default {
    name: 'MethodOption',
    components: { CardBrandBadge },
    props: {
      selected: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      // Исчерпанный вариант: вместо радио крестик — выбрать его нельзя в принципе.
      crossed: {
        type: Boolean,
        default: false,
      },
      brand: {
        type: String,
        default: null,
      },
      title: {
        type: String,
        required: true,
      },
      subtitle: {
        type: String,
        default: null,
      },
      badge: {
        type: String,
        default: null,
      },
      mark: {
        type: String,
        default: null,
      },
      markClass: {
        type: String,
        default: null,
      },
    },
    methods: {
      onSelect () {
        if (!this.disabled) this.$emit('select')
      },
    },
  }
</script>

<style lang="less" scoped>
.payment-method {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 20px;
  margin-bottom: 8px;
  border: 1px solid #e0e4ea;
  border-radius: 6px;
  background-color: #fff;
  cursor: pointer;
  transition: border-color 0.15s ease;

  // выбранное состояние исключаем явно: иначе hover перебивает его по
  // специфичности и оранжевая рамка пропадает под курсором
  &:hover:not(&_disabled):not(&_selected) {
    border-color: #c4cdd9;
  }

  &_selected {
    border-color: @color-primary;
  }

  &_disabled {
    background-color: #f7f8fa;
    cursor: default;

    .payment-method__title,
    .payment-method__subtitle {
      color: rgba(0, 0, 0, 0.38);
    }
  }

  // v-radio-group тянет ширину — прижимаем к содержимому
  &__radio,
  &__crossed {
    flex: 0 0 auto;
    width: 24px;
  }

  &__brand {
    flex: 0 0 auto;
  }

  &__info {
    flex: 1 1 auto;
    min-width: 0;
  }

  &__title {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.87);
    letter-spacing: 0.5px;
  }

  &__badge {
    margin-left: 8px;
    font-size: 12px;
    font-weight: 600;
    color: #ea306b;
    letter-spacing: normal;
  }

  &__subtitle {
    margin-top: 2px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.54);
  }

  &__mark {
    flex: 0 0 auto;
    font-size: 13px;
    color: @color-primary;

    &_backup {
      color: rgba(0, 0, 0, 0.38);
    }

    &_used {
      color: #eb5757;
    }
  }
}
</style>
